import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Get the API base URL based on the environment
 */
export function getApiBaseUrl(): string {
  const nodeEnv = import.meta.env.VITE_NODE_ENV;
  
  if (nodeEnv === 'develop') {
    return 'https://finanzly-front.onrender.com';
  } else if (nodeEnv === 'production') {
    return 'https://finanzly-front-production.onrender.com';
  }
  
  // Default fallback to development
  return 'https://finanzly-front.onrender.com';
}

/**
 * Shuffle an array using Fisher-Yates algorithm
 * Returns a new shuffled array without modifying the original
 */
export function shuffleArray<T>(array: T[]): T[] {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}
